export const PRICE_EFFECT_TYPES = [
    { name: 'Value', label: 'Value', value: 'VALUE' },
    { name: 'Percentage', label: 'Percentage', value: 'PERCENTAGE' },
];

export const EFFECT_TYPES = [
    { name: 'INCREASE', label: 'INCREASE', value: 'INCREASE' },
    { name: 'DECREASE', label: 'DECREASE', value: 'DECREASE' },
];